/*global google*/

import React, { Component } from 'react'
import axios from 'axios'
import GoogleMapReact from 'google-map-react';
import styles from './styles.module.css'

import blacktowericon from './blacktower.png'
import blacknullicon from './icons/black-null.png'
import reddiamondicon from './icons/red-diamond.png'
import redsquareicon from './icons/red-square.png'
import yellowdiamondicon from './icons/yellow-diamond.png'
import yellowsquareicon from './icons/yellow-square.png'
import greendiamondicon from './icons/green-diamond.png'
import greensquareicon from './icons/green-square.png'
import greysquareicon from './icons/grey-square.png'
import lightorangediamondicon from './icons/light-orange-diamond.png'
import lightorangetriangleicon from './icons/light-orange-triangle.png'
import lightorangecircleicon from './icons/light-orange-circle.png'
import orangediamondicon from './icons/orange-diamond.png'
import orangetriangleicon from './icons/orange-triangle.png'
import orangecircleicon from './icons/orange-circle.png'

class AnalysisDetails extends Component {
  constructor(props) {
    super(props)
    this.data = {incumbents:[], selected_areas:{coordinates:[]}}
    this.map = null
    this.incumbents = []
    this.state = {
      chart_loaded:false,
      saveMapImage:false,
      generatingMapImages: false,
      prepareMapBackgroundForSave:false,
      hasAutosavedMapImage:false,
      havePolygonsLoaded: false,
      coverage_percentage: 0,
      interference_area: 0,
      inverse_coverage_percentage: 0,
      chart_min: 740,
      chart_max: 4000,
      unavail_color:"#ff8f05",
      available_color: "#0050E6",
      available_color_wide_enough: "#00D43F",
      unusable_color:"#D3D3D3",
      yellow: "#FFF05A",
      series_spec:{},
      series_index: -1,
      data:{incumbents:[], selected_areas:{coordinates:[]}},
      display: "after",
      incumbents:[],
      incumbent_towers:[],
      selected_regions:[],
      coverage_contours:[],
      interference_contours:[],
      grid_points:[],
      coverage_data: [],
      interference_data: {},
      interference_overlap_data: {},
      is_analysis_started: false,
      is_analysis_complete: false,
      default_center:{
        lat: 59.0084,
        lng: -3.1214,
      },
      is_mno_coverage_visible: true,
      is_mno_measurements_visible: {"lte": true, "umts": true, "gsm": true, "any": true},
      is_rno_network_areas_visible: true,
      is_rno_coverage_visible: true,
      is_rno_interference_visible: false,
      stations:[],
      selectedNetworkAreaBounds: {},
      rnoInterferenceBounds: {},
      analysis_resolution_m: 500,
      overlay_map: {}
    }
    this.series_lookup = [];

    this.icons = {
      "lte" : [blacknullicon, blacknullicon, lightorangediamondicon, orangediamondicon],
      "umts" : [blacknullicon, blacknullicon, lightorangetriangleicon, orangetriangleicon],
      "gsm" : [blacknullicon, blacknullicon, lightorangecircleicon, orangecircleicon],
      "rno" : [greysquareicon, redsquareicon, yellowsquareicon,greensquareicon],
      "any" : [blacknullicon, reddiamondicon, yellowdiamondicon, greendiamondicon]
    }

    this.submitAnalysisRequest = this.submitAnalysisRequest.bind(this);
    this.setAnalysisResolution = this.setAnalysisResolution.bind(this);
  }

  styleFeature = (feature) => {
    if (feature.getProperty('_layer') === 'mno_measurements') {
      // (note that raster icons are significantly faster at scale than a google path)

      const technology = feature.getProperty('technology');
      const service_level = feature.getProperty('service_level');
      const icon_url = this.icons[technology][service_level];

      return {
        icon: {
          url: icon_url,
          anchor: new google.maps.Point(16, 16)
        },
        visible: this.state.is_mno_measurements_visible[technology]
      }
    } else if (feature.getProperty('_layer') === 'rno_coverage_contours') {
      let color = '#0000cc';
      if (feature.getProperty('rx_power') >= -95) {
        color = '#00D43F';
      } else if (feature.getProperty('rx_power') >= -105) {
        color = this.state.yellow;
      } else if (feature.getProperty('rx_power') >= -117) {
        color = '#fc0303'
      }

      return {
        fillColor: color,
        fillOpacity: 0.7,
        strokeColor: color,
        strokeWeight: 0,
        visible: this.state.is_rno_coverage_visible,
        zIndex: 10000
      };
    } else if (feature.getProperty('_layer') === 'rno_interference_contours') {
      return {
        fillColor: '#777777',
        fillOpacity: 0.5,
        strokeColor: '#888888',
        strokeWeight: 0,
        visible: this.state.is_rno_interference_visible,
        zIndex: 9000
      };
    } else if (feature.getProperty('_layer') === 'interference_overlap') {

      return {
        fillColor: '#fc0303',
        fillOpacity: 0.6,
        strokeColor: '#fc0303',
        strokeWeight: 0,
        visible: this.state.is_rno_interference_visible && this.state.is_mno_coverage_visible,
        zIndex: 9001
      };
    }
  }

  configureMap = ({ map, maps }) => {
    this.map = map;
    map.setOptions({zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_LEFT
    }});

    map.data.addGeoJson(this.state.coverage_data)
    map.data.addGeoJson(this.state.interference_overlap_data)
    const rnoInterferenceGeoJson = map.data.addGeoJson(this.state.interference_data)

    const rnoInterferenceBounds = {east: -180, north: -90, south: 90, west: 180};
    rnoInterferenceGeoJson[0].getGeometry().forEachLatLng(point => {
      if (point.lng() > rnoInterferenceBounds.east)
        rnoInterferenceBounds.east = point.lng();
      if (point.lng() < rnoInterferenceBounds.west)
          rnoInterferenceBounds.west = point.lng();
      if (point.lat() > rnoInterferenceBounds.north)
          rnoInterferenceBounds.north = point.lat();
      if (point.lat() < rnoInterferenceBounds.south)
          rnoInterferenceBounds.south = point.lat();
    });

    this.setState({rnoInterferenceBounds: rnoInterferenceBounds});

    // center/zoom the map to suit the user's network areas
    const selectedNetworkAreaBounds = {east: -180, north: -90, south: 90, west: 180};

    if (this.props.allPageStates.MapSelection.selected_overlay_index >= 0) {
      const overlayMapName = this.props.allPageStates.MapSelection.overlayMaps[this.props.allPageStates.MapSelection.selected_overlay_index].name;
      const overlayMap = {
        getTileUrl: function (coord, zoom) {
          const url = `${process.env.REACT_APP_LAL_ENDPOINT}/mno_coverage_tiles/${overlayMapName.replace('-', '/')}/${zoom}/${coord.x}/${coord.y}.png`
          return url;
        },
        name: overlayMapName,
        tileSize: new google.maps.Size(256, 256),
        isPng: true,
        opacity: 0.8,
        minZoom: 7,
        maxZoom: 15
      }

      map.overlayMapTypes.setAt(0, new google.maps.ImageMapType(overlayMap));
      this.setState({overlayMap: overlayMap})
    } else {
      // user has selected a frequency for which there is no coverage map
      this.setState({overlayMap: null})
    }

    this.props.allPageStates.MapSelection.selectedNetworkAreas.forEach(area => {
      area.forEach(point => {
        if (point.lng > selectedNetworkAreaBounds.east)
          selectedNetworkAreaBounds.east = point.lng;
        if (point.lng < selectedNetworkAreaBounds.west)
          selectedNetworkAreaBounds.west = point.lng;
        if (point.lat > selectedNetworkAreaBounds.north)
          selectedNetworkAreaBounds.north = point.lat;
        if (point.lat < selectedNetworkAreaBounds.south)
          selectedNetworkAreaBounds.south = point.lat;
      })
    });

    this.setState({selectedNetworkAreaBounds: selectedNetworkAreaBounds})
    map.fitBounds(selectedNetworkAreaBounds);

    let infowindow = new maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, -20)
    });

    map.setMapTypeId('terrain');

    let areas = []
    for (let path of this.props.allPageStates.MapSelection.selectedNetworkAreas) {
      let polygon = new google.maps.Polygon({
          paths: path,
          strokeColor: '#0050E6',
          strokeOpacity: 1,
          strokeWeight: 3,
          fillColor: '#0050E6',
          fillOpacity: 0.1,
          zIndex: 9999999
          })
      polygon.setMap(map);
      areas.push(polygon)
    }
    this.setState({selected_regions:areas})

    map.data.setStyle(this.styleFeature);

    this.setState({stations: this.props.allPageStates.TransmittingStations});

    this.props.allPageStates.TransmittingStations.stations.forEach(station => {
      var sectorData = ``
      for (var sector in station.sectors) {
        sectorData = `${sectorData}<b>Sector ${sector} </b><br/> AGL:${station["sectors"][sector]["elevation_m_AGL"]}m, Azimuth ${station["sectors"][sector]["azimuth"]}°, Polarization ${station["sectors"][sector]["polarization"]}, EIRP ${station["sectors"][sector]["eirp_dbm"]} dBm </b><br/>`
      }

      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(station.lat),
          lng: parseFloat(station.long)
        },
        map,
        icon: blacktowericon,
      });

      marker.addListener('click', () => {
        map.setZoom(10);
        map.setCenter(marker.getPosition());
        var html = `
        <font size="3.5">
        <b>Lat: ${station.lat}, Long: ${station.long}</b><br/> 
        ${sectorData}
        </font size="3.5">
        `;
        infowindow.setContent(html);
        infowindow.open(this.map, marker, html);
      });
    });

    [].forEach.call(document.getElementsByClassName(styles.customMapControl), function (el) {
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(el);
    });


    map.data.addListener('mouseover', function(event) {
      if (event.feature.getProperty('_layer') !== 'mno_measurements')
        return;

      const service_level = event.feature.getProperty('service_level');
      const service_level_name = service_level === 3 ? 'Good' : service_level === 2 ? 'Variable' : service_level === 1 ? 'Poor' : 'None';
      const technology = event.feature.getProperty('technology');
      const technology_metrics = event.feature.getProperty('technology_metrics');

      infowindow.setContent(`
        <div>${event.feature.getProperty('entity_name')} ${technology !== 'any' ? technology.toUpperCase() : ""}${event.feature.getProperty('band')}</div>
        <div>Service Level: ${service_level_name}</div>
        <div>${event.feature.getProperty('arfcn') ? "ARFCN: " + event.feature.getProperty('arfcn') : ""} (${event.feature.getProperty('lower_freq_MHz')}-${event.feature.getProperty('upper_freq_MHz')}MHz)</div>
        
        <div>
          ${technology === 'lte' ? "Cell ID:" + technology_metrics.pci + "</div><div>RSRP: " + technology_metrics.rsrp + "dBm</div><div>RSRQ:" + technology_metrics.rsrq + "dBm" : ""}
          ${technology === 'umts' ? "RSCP: " + technology_metrics.rscp + "dBm" : ""}
          ${technology === 'gsm' ? "Station ID:" + technology_metrics.bsic + "</div><div>RX level: " + technology_metrics.rx_level + "dBm" : ""}
        </div>            
        
        <div>Measured at ${event.feature.getProperty('timestamp')}</div>
      `);
      infowindow.setPosition(event.latLng);

      infowindow.open(map);
    });

    map.data.addListener('mouseout', function(event) {
      if (event.feature.getProperty('_layer') === 'mno_measurements')
        infowindow.close();
    });

    map.addListener('tilesloaded', () => {
      this.props.prepareMapBackgroundForSave();


      // Visible map bounds
      const bounds = map.getBounds();
      const n = bounds.getNorthEast().lat();
      const e = bounds.getNorthEast().lng();
      const s = bounds.getSouthWest().lat();
      const w = bounds.getSouthWest().lng();

      // remove old features to avoid flickering
      const oldFeatures = [];
      map.data.forEach(f => oldFeatures.push(f));

      // retrieve geojson from back-end
      const selected_freqs = this.props.allPageStates.MapSelection.selected_freqs;
      axios.get(`${process.env.REACT_APP_LAL_ENDPOINT}/mno_measurements/${n}/${e}/${s}/${w}/${selected_freqs[0].toFixed(1)}/${selected_freqs[1].toFixed(1)}/${map.getZoom()}`)
        .then(response => map.data.addGeoJson(response.data))
        .then(() => {
          oldFeatures.forEach(f => {
            if (f.getProperty("_layer") === 'mno_measurements')
              map.data.remove(f);
          });
        })
        .finally(() => {
          this.setState({havePolygonsLoaded: true})
        });
    });

    this.toggle_measurements_lte = () => this.toggle_measurements('lte');
    this.toggle_measurements_umts = () => this.toggle_measurements('umts');
    this.toggle_measurements_gsm = () => this.toggle_measurements('gsm');
    this.toggle_measurements_any = () => this.toggle_measurements('any');

    this.toggle_measurements = (technology) => {
      let is_mno_measurements_visible = this.state.is_mno_measurements_visible;
      is_mno_measurements_visible[technology] = !is_mno_measurements_visible[technology];

      this.setState({is_mno_measurements_visible: is_mno_measurements_visible});
      map.data.setStyle(this.styleFeature);
    }

    this.toggle_mno_coverage = () => {
      this.setState({is_mno_coverage_visible: !this.state.is_mno_coverage_visible}, this.show_hide_mno_coverage);
      map.data.setStyle(this.styleFeature);
    }

    this.show_hide_mno_coverage = () => {
      if (this.state.is_mno_coverage_visible && this.state.overlayMap !== null) {
        map.overlayMapTypes.setAt(0, new google.maps.ImageMapType(this.state.overlayMap));
        setTimeout(() => {
          this.props.prepareMapBackgroundForSave();
        }, 2000)
      } else {
        map.overlayMapTypes.clear()
      }
    }

    this.toggle_network_areas = () => {
      this.state.selected_regions.forEach((sr) => sr.setVisible(!sr.getVisible()));
      this.setState({is_rno_network_areas_visible: !this.state.is_rno_network_areas_visible})
    }

    this.toggle_rno_coverage_contours = () => {
      if (!this.state.is_rno_coverage_visible && this.state.is_rno_interference_visible)
        this.setState({"is_rno_interference_visible": !this.state.is_rno_interference_visible});
      this.setState({"is_rno_coverage_visible": !this.state.is_rno_coverage_visible});
      map.data.setStyle(this.styleFeature);
    }

    this.toggle_rno_interference_contours = () => {
      if (!this.state.is_rno_interference_visible && this.state.is_rno_coverage_visible)
          this.setState({"is_rno_coverage_visible": !this.state.is_rno_coverage_visible});
      this.setState({"is_rno_interference_visible": !this.state.is_rno_interference_visible});
      map.data.setStyle(this.styleFeature);
    }
  }

  getMapOptions() {
    return {
      gestureHandling:'greedy',
      scaleControl: true,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {color: '#f5fcff'}
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry.fill',
          stylers: [
            {lightness: -5}
          ]
        }
      ]
    }
  }

  setAnalysisResolution(event) {
    const analysis_resolution_m = parseInt(event.target.value);
    this.setState({analysis_resolution_m: analysis_resolution_m});
  }

  submitAnalysisRequest() {
    const url = `${this.props.SERVER_URLS.api}/analysis/${this.props.requestID}`

    const analysis_job = {
      "sites": this.props.allPageStates.TransmittingStations.stations,
      "network_areas" : this.props.allPageStates.MapSelection.selectedNetworkAreas,
      "center_freq_MHz" : (this.props.allPageStates.MapSelection.selected_freqs[0] + this.props.allPageStates.MapSelection.selected_freqs[1]) / 2.0,
      "resolution_m" : this.state.analysis_resolution_m
    }

    this.setState({is_analysis_started: true,
                   is_analysis_complete: false});

    axios.post(url, analysis_job)
    .then(response =>{
      this.pollForAnalysisResult()
    })
    .catch(error => {
        console.log(error)
    })
  }

  pollForAnalysisResult() {
    this.timer = setInterval(()=> {
      let URL = `${this.props.SERVER_URLS.api}/analysis/${this.props.requestID}`
      axios.get(URL)
      .then(response => {
        if (this._isMounted) {
          if (response && response.data && response.data.status=== "Success"){
            this.modifyState({
                coverage_data: response.data.coverage,
                interference_data: response.data.interference,
                interference_overlap_data: response.data.interference_overlap,
                coverage_percentage: Math.round(response.data.overlap_percentages[0]),
                interference_area: Math.round(response.data.overlap_percentages[1]),
                inverse_coverage_percentage: Math.round(response.data.overlap_percentages[2]),
                is_analysis_started: true,
                is_analysis_complete: true
            })
            clearInterval(this.timer)
          }

          if (response.data.status === "Failed"){
            clearInterval(this.timer)
          }          
        } else {
            clearInterval(this.timer)
        }
      }).catch((error) => {
          console.log(error);
      })        
    }, 1000);
  }

  modifyState = (state, callback) => {
    this.setState(state, callback);
    this.props.updatePageState("AnalysisDetails", state);
  }

  componentDidMount() {
    this._isMounted = true   
    if (this.props.getPageState("AnalysisDetails")){
        this.setState(this.props.getPageState("AnalysisDetails"));
        return;
    }
  }

  componentWillUnmount() {
    this._isMounted = false
    clearInterval(this.timer)
    this.timer=null
    let URL = `${this.props.SERVER_URLS.api}/request/${this.props.requestID}`
    axios.put(URL, {"user_id": localStorage.getItem("user_id"), "payload": {"requested_band":
      {"lower_freq": this.series_lookup[this.state.series_index], "upper_freq": this.series_lookup[this.state.series_index+1]}}})
  }

  getIncumbentUserOfSelection() {
    const series_index = this.props.allPageStates.MapSelection.series_index;

    return series_index >= 0 ? this.props.allPageStates.MapSelection.series_lookup[series_index][2] : "";
  }

  getSelectedFrequencyRange() {
    const series_index = this.props.allPageStates.MapSelection.series_index;

    return series_index >= 0 ? `${this.props.allPageStates.MapSelection.series_lookup[this.props.allPageStates.MapSelection.series_index][0]} to ${this.props.allPageStates.MapSelection.series_lookup[this.props.allPageStates.MapSelection.series_index][1]} MHz` : "";
  }

  hijackMapAndSaveMapImage = (hijackMap, imageName, waitForTilesLoaded, timeoutMs) => {
    console.log(imageName)
    const _this = this;

    return new Promise((resolve, reject) => {
      this.setState({havePolygonsLoaded: false}, resolve);
    })
      .then(() => {
        hijackMap();

        return new Promise((resolve, reject) => {
          let tryToSaveMapImage = () => {
            try {
              if (waitForTilesLoaded && !_this.state.havePolygonsLoaded)
                throw "Polygons (and by inference tiles) have not loaded"

              _this.props.saveMapImage(imageName);
              resolve();
            } catch (e) {
              console.log(e);
              _this.props.prepareMapBackgroundForSave();
              setTimeout(() => {
                tryToSaveMapImage();
              }, 500);
            }
          }

          setTimeout(() => {
            tryToSaveMapImage();
          }, timeoutMs);
        });
      })
  };

  generateSavedMapImages(callback) {
    // The OfW588 Appendices need a series of images as supporting evidence.
    // We will generate these from the map and its various overlays.
    // This is achieved by scripting various pan/zoom/(un)hide operations to hijack the visible map
    // and then executing a (custom) screenshot method to store each image as base64 in the state object
    // Warning: Due to a lack of callback/promise support from the underlying Google Maps API,
    // parts of this are held together with timeouts (...) which won't be 100% reliable and may need to be tweaked.

    this.hijackMapAndSaveMapImage(() => {
      // force redraw in case user happens to be in the right place at the start
      this.map.setZoom(20);
    }, "throwaway", true,1000)
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": false, "umts": false, "gsm": false, "any": false},
            is_mno_coverage_visible: false,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: false,
            is_rno_interference_visible: false
          });

          this.map.data.setStyle(this.styleFeature);
          this.show_hide_mno_coverage();

          this.map.fitBounds(this.state.selectedNetworkAreaBounds);
        }, "intended_service", true, 1000)
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": false, "umts": false, "gsm": false, "any": false},
            is_mno_coverage_visible: false,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: true,
            is_rno_interference_visible: false
          }, this.show_hide_mno_coverage);

          this.map.data.setStyle(this.styleFeature);
        }, "intended_service_and_coverage", false,1000)
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          // force redraw in case user happens to be in the right place at the start
          this.map.setZoom(20);
        }, "throwaway", true,1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": false, "umts": false, "gsm": false, "any": false},
            is_mno_coverage_visible: true,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: false,
            is_rno_interference_visible: true
          }, this.show_hide_mno_coverage);

          // this is async and there is no promise returned or callback hook or event to listen for.
          this.map.data.setStyle(this.styleFeature);
          this.map.fitBounds(this.state.rnoInterferenceBounds);
          this.map.setZoom(this.map.getZoom() + 1);
        }, "interference", true, 1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          // force redraw in case user happens to be in the right place at the start
          this.map.setZoom(20);
        }, "throwaway", true,1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": false, "umts": false, "gsm": false, "any": false},
            is_mno_coverage_visible: true,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: true,
            is_rno_interference_visible: false
          }, this.show_hide_mno_coverage);

          // this is async and there is no promise returned or callback hook or event to listen for.
          this.map.data.setStyle(this.styleFeature);
          this.map.fitBounds(this.state.rnoInterferenceBounds);
          this.map.setZoom(this.map.getZoom() + 1);
        }, "coverage", true, 1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          // force redraw in case user happens to be in the right place at the start
          this.map.setZoom(20);
        }, "throwaway", true,1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": false, "umts": false, "gsm": false, "any": false},
            is_mno_coverage_visible: true,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: true,
            is_rno_interference_visible: false
          }, this.show_hide_mno_coverage);

          this.map.fitBounds(this.state.selectedNetworkAreaBounds, -20);
          // this is async and there is no promise returned or callback hook or event to listen for.
          this.map.data.setStyle(this.styleFeature);
        }, "neighbourhood", true, 1000);
      })
      .then(() => {
        return this.hijackMapAndSaveMapImage(() => {
          this.setState({
            is_mno_measurements_visible: {"lte": true, "umts": true, "gsm": true, "any": true},
            is_mno_coverage_visible: true,
            is_rno_network_areas_visible: true,
            is_rno_coverage_visible: true,
            is_rno_interference_visible: false
          }, this.show_hide_mno_coverage);

          // this is async and there is no promise returned or callback hook or event to listen for.
          this.map.data.setStyle(this.styleFeature);
        }, "field_measurements", false,1000);
      })
      .then(() => {
        this.setState({generatingMapImages: false});
        callback();
      });

    this.setState({generatingMapImages: true});
  }

  render() {
    var {handleSubmit, previousPage, saveAndExit} = this.props;

    if (!this.state.is_analysis_started){
        return (
          <div>
            <h3>Step 4: Analyse the predicted coverage and interference of your network <em>for Ofcom OfW588 form, Sections C13</em></h3>

            <p>An analysis will be run on your network design to assess the coverage area, and to assess whether it will cause interference to MNOs. Depending on your choice of detail level, this will take a few seconds up to a minute.</p>

            <div className="detail-select">
              <React.Fragment>
                <label>Analysis detail level:</label>

                <select value={this.state.analysis_resolution_m} onChange={this.setAnalysisResolution}>
                  <option value="2000">2km (fastest, least detailed)</option>
                  <option value="1000">1km</option>
                  <option value="500">500m</option>
                  <option value="250">250m (slowest, most detailed)</option>
                </select>

              </React.Fragment>
            </div>

            <div className="button-row">
              <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={previousPage}>
                  Previous Page
              </button>
              <button type="button" className="btn btn-primary btn-lg" disabled={false} onClick={this.submitAnalysisRequest}>
                  Start Analysis
              </button>
            </div>
          </div>
          )
    }

    if (this.state.is_analysis_started && !this.state.is_analysis_complete){
        return (
          <div>
            <h3>Step 4: Analyse the predicted coverage and interference of your network <em>for Ofcom OfW588 form, Sections C13</em></h3>

            <center>
              <div className="transparent-spinner"/>
            </center>

            <div className="button-row">
              <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={previousPage}>
                  Previous Page
              </button>
            </div>
          </div>)
    }

    return (
      <React.Fragment>
        <div>
          <h3>Step 4: Analyse the predicted coverage and interference of your network <em>for Ofcom OfW588 form, Sections C13</em></h3>

          <React.Fragment>
            <div style={{ height: '60vh', width: '100%' }}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: localStorage.getItem("google_maps_api_key"),
                  language: 'en',
                }}
                defaultCenter={this.state.default_center}
                defaultZoom={8}

                options={this.getMapOptions()}
                onGoogleApiLoaded={this.configureMap}
                yesIWantToUseGoogleMapApiInternals
              />
            </div>

            <div className={'alert ' + (this.state.coverage_percentage >= 66 ? 'alert-success' : 'alert-danger')} role="alert">
              {this.state.coverage_percentage >= 66 ?
                `${this.state.coverage_percentage}% of your intended coverage area will receive good signal from your transmitters - you have not under-provisioned.` :
                `Only ${this.state.coverage_percentage}% of your intended coverage area will receive good signal from your transmitters - you have under-provisioned. Increase the number, height, or power of your transmitters, move your transmitters to higher ground, or choose a smaller intended coverage area.`}
            </div>

            <div className={'alert ' + (this.state.coverage_percentage >= 66 ? '' : 'hidden ') + (this.state.inverse_coverage_percentage >= 50 ? 'alert-success' : 'alert-danger')} role="alert">
              {this.state.inverse_coverage_percentage >= 50 ?
                `${this.state.inverse_coverage_percentage}% of your good signal area is in your intended coverage area - you have not over-provisioned.` :
                `Only ${this.state.inverse_coverage_percentage}% of your good signal area is in your intended coverage area - you may have over-provisioned. Decrease the number, height, or power of your transmitters.`}
            </div>

            <div className={'alert ' + (this.state.interference_area <= 5 ? 'alert-success' : 'alert-danger')} role="alert">
              {this.state.interference_area <= 5 ? `Only ${this.state.interference_area}` : `${this.state.interference_area}`}
              km<sup>2</sup> of the area where your transmitters can cause interference overlaps with an MNO's coverage area.
              {this.state.interference_area <= 5 ? `` : ' Decrease the number, height, or power of your transmitters, move them or point them away from MNO coverage areas, or choose a different frequency range.'}
            </div>

            <div className={styles.customMapControl}>
              <div>
                <svg height="3em" width="3em" viewBox="0 0 301 301" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <rect fill="none" height="303" width="303" y="-1" x="-1"/>
                    <rect transform="rotate(30.433414459228516 151,149.953125) " height="148" width="242" y="75.95313" x="30" fillOpacity="0.1" strokeWidth="20" stroke="#0050E6" fill="#0050E6"/>
                  </g>
                </svg>
                <span>Your intended coverage area(s)</span>
                <input
                      name="show_areas"
                      type="checkbox"
                      onChange={()=>this.toggle_network_areas()}
                      checked={this.state.is_rno_network_areas_visible}
                      />
                      
              </div>

              <div>
                <img className={styles.unsquashIcon} alt="" src={blacktowericon}/> Your proposed transmitters
              </div>

              <div>
                <input
                name="show_rno_coverage"
                component="input"
                type="checkbox"
                onChange={()=>this.toggle_rno_coverage_contours()}
                checked={this.state.is_rno_coverage_visible}
                />
                <img className={styles.squashIcon} alt="" src={this.icons['rno'][3]}/><img className={styles.squashIcon} alt="" src={this.icons['rno'][2]}/> Your simulated signal strength
              </div>

              <div>
                <input
                name="show_rno_interference"
                component="input"
                type="checkbox"
                onChange={()=>this.toggle_rno_interference_contours()}
                checked={this.state.is_rno_interference_visible}
                />
                <img className={styles.squashIcon} src={this.icons['rno'][0]} alt=""/>
                <img className={styles.squashIcon} src={this.icons['rno'][1]} alt=""/>
                Your simulated interference caused
              </div>

              <div>
                <svg height="3em" width="3em" viewBox="0 0 301 301" xmlns="http://www.w3.org/2000/svg">
                 <g>
                  <rect fill="none" height="303" width="303" y="-1" x="-1"/>
                  <ellipse fillOpacity="0.125" ry="145" rx="145" cy="150.25" cx="150.25" strokeWidth="8" stroke="#ff8f05" fill="#ff8f05"/>
                 </g>
                </svg>
                <span>{this.getIncumbentUserOfSelection()} coverage in {this.getSelectedFrequencyRange()}</span>
                  <input
                  name="show_incumbents"
                  component="input"
                  type="checkbox"
                  onChange={()=>this.toggle_mno_coverage()}
                  checked={this.state.is_mno_coverage_visible}
                  />{' '}
              </div>

              <div>
                <img className={styles.squashIcon} alt="" src={this.icons['lte'][3]}/><img className={styles.squashIcon} alt="" src={this.icons['lte'][2]}/> 4G (LTE) field measurements
                <input
                  name="show_lte"
                  component="input"
                  type="checkbox"
                  onChange={()=>this.toggle_measurements_lte()}
                  checked={this.state.is_mno_measurements_visible.lte}
                />
              </div>
              <div>
                <img className={styles.squashIcon} alt="" src={this.icons['umts'][3]}/><img className={styles.squashIcon} alt="" src={this.icons['umts'][2]}/> 3G (UMTS) field measurements
                <input
                  name="show_umts"
                  component="input"
                  type="checkbox"
                  onChange={()=>this.toggle_measurements_umts()}
                  checked={this.state.is_mno_measurements_visible.umts}
                />
              </div>
              <div>
                <img className={styles.squashIcon} alt="" src={this.icons['gsm'][3]}/><img className={styles.squashIcon} alt="" src={this.icons['gsm'][2]}/> 2G (GSM) field measurements
                <input
                  name="show_gsm"
                  component="input"
                  type="checkbox"
                  onChange={()=>this.toggle_measurements_gsm()}
                  checked={this.state.is_mno_measurements_visible.gsm}
                />
              </div>
              <div>
                <img alt="" src={this.icons['any'][0]}/> No Signal field measurements
                <input
                  name="show_any"
                  component="input"
                  type="checkbox"
                  onChange={()=>this.toggle_measurements_any()}
                  checked={this.state.is_mno_measurements_visible.any}
                />
              </div>
            </div>
          </React.Fragment>

          <div className="button-row">
            <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={()=>
              {
                  this.modifyState({is_analysis_started: false, is_analysis_complete: false})
                  previousPage()
              }}>
                Previous Page
            </button>
            <button type="button" className="btn btn-light btn-lg" disabled={false} onClick={()=>{saveAndExit()}}>Save and Exit</button>
            <button type="button" className="btn btn-primary btn-lg" disabled={false} onClick={() => {this.generateSavedMapImages(this.props.onSubmit);}}>Next Page</button>
          </div>
          {this.state.generatingMapImages &&
            <div className="generating-map-images">
              <h3>Generating images for OfW588 Appendices</h3>
              <div className="transparent-spinner"/>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}


  export default AnalysisDetails

